import { CallStateEnum } from '@models/call-state.model.ts';
import {
  getMediaLibraryMoveTreeData,
  moveFolder,
  moveMedia
} from '@api/media-library-api.ts';
import { SnackbarType } from '@models/app-snackbar.model.ts';
import useSnackbarStore from '@store/snackbar-store/snackbar.store.ts';
import axios from 'axios';
import { MediaLibraryActionParams } from '@store/media-library-store/media-library.model.ts';

const { showSnackbar } = useSnackbarStore.getState();

export const moveTreeSlice = (set: any, get: any) => ({
  getMoveTreeData: async () => {
    set({ moveTreeCallState: CallStateEnum.Loading });

    try {
      const data = await getMediaLibraryMoveTreeData();

      set({
        moveTreeCallState: CallStateEnum.Loaded,
        moveTreeData: data
      });
    } catch (error) {
      set({ moveTreeCallState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  },
  moveFolder: async ({ data, handleClose }: MediaLibraryActionParams) => {
    set({ folderCallState: CallStateEnum.Loading });
    try {
      await moveFolder(data);
      set({ folderCallState: CallStateEnum.Loaded });
      handleClose?.();
      get().getMediaLibraryFolders(
        get().currentFolder.id,
        get().currentFolder.title
      );
      get().getMedia(get().currentFolder.id);
      showSnackbar('snackbar_move_folder_text', SnackbarType.Success);
    } catch (error: any) {
      set({ folderCallState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  },

  moveMedia: async ({ data, handleClose }: MediaLibraryActionParams) => {
    set({ folderCallState: CallStateEnum.Loading });
    try {
      await moveMedia(data);
      set({ folderCallState: CallStateEnum.Loaded });
      handleClose?.();
      get().getMediaLibraryFolders(
        get().currentFolder.id,
        get().currentFolder.title
      );
      get().getMedia(get().currentFolder.id);
      showSnackbar('snackbar_move_media_text', SnackbarType.Success);
    } catch (error: any) {
      set({ folderCallState: CallStateEnum.Error });
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message;
        showSnackbar(message, SnackbarType.Error);
      }
    }
  }
});
